import RestModel from './RestModel';

const resourceName = 'social-networks';

export default {
    list: () => RestModel.list(resourceName)
};
